import { render, staticRenderFns } from "./ChatPlus.vue?vue&type=template&id=2b062e65"
import script from "./ChatPlus.vue?vue&type=script&lang=js"
export * from "./ChatPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports